// ==============================|| I18N - ESPAÑOL ||============================== //
// Diccionario plano: la clave es la ruta con puntos y el valor el texto final.
// Se mantiene plano a propósito — buscar una clave en el código y encontrarla
// aquí es una sola búsqueda de texto, sin recorrer objetos anidados.
//
// `{{parametro}}` se sustituye al traducir (ver `translate` en ../translate.js).

const es = {
  'common.save': 'Guardar',
  'common.saving': 'Guardando...',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.edit': 'Editar',
  'common.back': 'Volver',
  'common.loading': 'Cargando...',
  'common.actions': 'Acciones',
  'common.status': 'Estado',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.noPermission': 'No tienes permisos para consultar esta información.',
  'common.unexpectedError': 'Ocurrió un error inesperado.',
  'common.all': 'Todos',
  'common.confirm': 'Confirmar',

  'dashboard.title': 'Dashboard',
  'dashboard.totalRoutes': 'Total rutas',
  'dashboard.totalWorkers': 'Total trabajadores',
  'dashboard.totalBoxes': 'Cajas activas',
  'dashboard.totalLoans': 'Préstamos',
  'dashboard.totalCollections': 'Recaudos',
  'dashboard.overview': 'Resumen del negocio',
  'dashboard.uniqueVisitor': 'Visitantes únicos',
  'dashboard.salesReport': 'Reporte de ventas',
  'dashboard.recentOrders': 'Pedidos recientes',
  'dashboard.analyticsReport': 'Reporte analítico',

  'language.label': 'Idioma',
  'language.change': 'Cambiar idioma',

  'routes.title': 'Rutas',
  'routes.create': 'Crear ruta',
  'routes.creating': 'Guardando ruta...',
  'routes.edit': 'Editar ruta',
  'routes.backToList': 'Volver al listado de rutas',
  'routes.id': 'ID consecutivo',
  'routes.idHelp': 'Lo genera el sistema al crear la ruta.',
  'routes.idPlaceholder': 'Se asigna al guardar',
  'routes.name': 'Nombre',
  'routes.description': 'Descripción',
  'routes.number': 'Número de ruta',
  'routes.country': 'País',
  'routes.state': 'Departamento / Estado',
  'routes.city': 'Ciudad',
  'routes.currency': 'Moneda',
  'routes.currencyUnavailable': 'El catálogo todavía no informa la moneda de este país.',
  'routes.currencyFromCountry': 'La moneda la determina el país seleccionado.',
  'routes.location': 'Ubicación',
  'routes.initialValue': 'Valor inicial',
  'routes.maxSale': 'Venta máxima',
  'routes.expenses': 'Gastos',
  'routes.workingDays': 'Días de trabajo',
  'routes.frequency': 'Frecuencia de cobro',
  'routes.automaticOpening': 'Apertura automática de caja',
  'routes.automaticOpeningOn': 'La caja se abrirá automáticamente en los días de trabajo seleccionados.',
  'routes.automaticOpeningNeedsDays': 'Selecciona al menos un día de trabajo para habilitar la apertura automática.',
  'routes.cashOpening': 'Apertura de caja',
  'routes.cashOpeningAutomatic': 'Automática',
  'routes.cashOpeningManual': 'Manual',
  'routes.collector': 'Cobrador',
  'routes.collectorUnassigned': 'Sin asignar',
  'routes.collectorManagedElsewhere': 'La asignación de trabajadores se gestiona desde Gestión de trabajadores.',
  'routes.users': 'Usuarios que pueden ver la ruta',
  'routes.usersEmpty': 'Esta ruta no tiene usuarios autorizados.',
  'routes.usersHidden': 'Esta ruta tiene {{count}} usuario(s) autorizado(s).',
  'routes.usersSearch': 'Buscar usuario...',
  'routes.usersNotFound': 'Usuario no encontrado',
  'routes.usersLoadError': 'No se pudo cargar el catálogo de usuarios',
  'routes.usersLoading': 'Cargando usuarios...',
  'routes.sectionInformation': 'Información',
  'routes.sectionPermissions': 'Permisos',
  'routes.sectionDaysAndFrequency': 'Días de trabajo y frecuencia',
  'routes.sectionCashAndCollection': 'Configuración de caja y cobro',
  'routes.clients': 'Clientes de la ruta',
  'routes.clientsAdd': 'Agregar clientes',
  'routes.clientsEmpty': 'Esta ruta todavía no tiene clientes asignados.',
  'routes.listEmpty': 'No hay rutas que coincidan con el filtro.',
  'routes.allCollectors': 'Todos los cobradores',
  'routes.allStatuses': 'Todos los estados',
  'routes.created': 'Ruta "{{nombre}}" creada correctamente con el consecutivo {{consecutivo}}.',
  'routes.deactivate': 'Desactivar ruta',
  'routes.deactivateConfirm': '¿Desactivar la ruta "{{nombre}}"?',
  'routes.deactivateAction': 'Desactivar',
  'routes.removeClient': 'Quitar cliente de la ruta',
  'routes.removeClientConfirm': '¿Quitar a {{nombre}} de esta ruta?',
  'routes.removeClientAction': 'Quitar',
  'routes.removeClientTooltip': 'Quitar de la ruta',
  'routes.viewDetail': 'Ver detalle',
  'routes.createError': 'No se pudo crear la ruta.',
  'routes.createForbidden': 'No tienes permisos para crear rutas.',
  'routes.updateForbidden': 'No tienes permisos para editar rutas.',
  'routes.updateError': 'No se pudo guardar la ruta.',

  'routes.validation.name': 'El nombre es obligatorio',
  'routes.validation.number': 'El número de ruta es obligatorio y debe ser numérico',
  'routes.validation.initialValue': 'El valor inicial es obligatorio y debe ser numérico',
  'routes.validation.users': 'Selecciona al menos un usuario que pueda ver la ruta',
  'routes.validation.country': 'El país es obligatorio',
  'routes.validation.state': 'El departamento es obligatorio',
  'routes.validation.city': 'La ciudad es obligatoria',
  'routes.validation.maxSale': 'La venta máxima es obligatoria y debe ser numérica',
  'routes.validation.expenses': 'El valor de gastos es obligatorio y debe ser numérico',
  'routes.validation.workingDays': 'Selecciona al menos un día de trabajo',
  'routes.validation.automaticOpening': 'La apertura automática de caja requiere al menos un día de trabajo',
  'routes.validation.frequency': 'La frecuencia de cobro es obligatoria',

  'routes.edit.lockedBySales': 'No se puede modificar porque la ruta ya tiene ventas registradas.',
  'routes.edit.lockedByContract': 'Este campo todavía no se puede modificar desde esta pantalla.',
  'routes.edit.lockedNotice': 'Los campos deshabilitados conservan su valor actual: se muestran para consulta y no se envían al guardar.',

  'location.selectCountry': 'Seleccione un país',
  'location.selectState': 'Seleccione un departamento',
  'location.selectCity': 'Seleccione una ciudad',
  'location.selectCountryFirst': 'Seleccione primero un país',
  'location.selectStateFirst': 'Seleccione primero un departamento',
  'location.loadingCountries': 'Cargando países...',
  'location.loadingStates': 'Cargando departamentos...',
  'location.loadingCities': 'Cargando ciudades...',
  'location.countriesError': 'No se pudo cargar el listado de países.',
  'location.statesError': 'No se pudo cargar el listado de departamentos.',
  'location.citiesError': 'No se pudo cargar el listado de ciudades.',
  'location.countriesEmpty': 'El catálogo de países está vacío.',
  'location.statesEmpty': 'Este país todavía no tiene departamentos cargados.',
  'location.citiesEmpty': 'Este departamento todavía no tiene ciudades cargadas.',

  'cash.title': 'Caja',
  'cash.name': 'Caja',
  'cash.businessDate': 'Fecha de negocio',
  'cash.openingDate': 'Fecha de apertura',
  'cash.route': 'Ruta',
  'cash.worker': 'Trabajador',
  'cash.selectRoute': 'Selecciona una ruta',
  'cash.selectRouteFirst': 'Selecciona una ruta para consultar sus cajas.',
  'cash.empty': 'No hay cajas para esta ruta.',
  'cash.open': 'Abrir nueva caja',
  'cash.openAction': 'Abrir caja',
  'cash.initialAmount': 'Monto inicial',
  'cash.initialAmountCarryOver': 'Es el saldo con el que cerró la última caja de esta ruta.',
  'cash.initialAmountRouteDefault': 'Es el valor inicial configurado para esta ruta: todavía no ha tenido ninguna caja.',
  'cash.columnInitialAmount': 'Monto inicial',
  'cash.columnClosingAmount': 'Monto de cierre',
  'cash.noWorker': 'Esta ruta no tiene un cobrador asignado: no se puede abrir una caja sin saber para quién.',
  'cash.incident': 'Incidencia',
  'cash.statusOpen': 'Abierta',
  'cash.statusClosed': 'Cerrada',
  'cash.statusForceClosed': 'Cierre forzado',
  'cash.statusUnknown': 'Desconocido',
  'cash.operations': 'Operaciones disponibles',
  'cash.forceClose': 'Cerrar caja mediante cierre forzado',
  'cash.forceCloseDescription': 'Esta caja se cerrará de forma forzada. Es posible que existan movimientos no sincronizados.',
  'cash.forceCloseConfirm': 'Cerrar caja',
  'cash.reopen': 'Reabrir caja',
  'cash.reopenDescription': '¿Reabrir esta caja cerrada forzadamente?',
  'cash.showMore': 'Ver más cajas',

  'installments.mark': 'Marcar cuota',
  'installments.markShort': 'Marcar',
  'installments.markTitle': 'Marcar cuota {{numero}}',
  'installments.client': 'Cliente',
  'installments.number': 'Cuota',
  'installments.dueDate': 'Vencimiento',
  'installments.amount': 'Valor de la cuota',
  'installments.pending': 'Pendiente por pagar',
  'installments.pendingShort': 'Pendiente',
  'installments.amountToRegister': 'Monto a registrar',
  'installments.paymentMethod': 'Método de pago',
  'installments.notes': 'Notas (opcional)',
  'installments.confirmTitle': 'Confirmar marcación de cuota',
  'installments.confirmDescription':
    'Se registrará un pago de {{monto}} sobre esta cuota. La operación afecta el saldo del préstamo y no puede deshacerse.',
  'installments.marking': 'Marcando cuota...',
  'installments.marked': 'Cuota marcada correctamente.',
  'installments.error': 'No se pudo marcar la cuota.',
  'installments.alreadyPaid': 'Esta cuota ya está pagada.',
  'installments.invalidAmount': 'Ingresa un monto mayor que cero y menor o igual al pendiente.',
  'installments.loanNotActive': 'Solo se pueden marcar cuotas de préstamos activos.',

  'days.LUNES': 'Lunes',
  'days.MARTES': 'Martes',
  'days.MIERCOLES': 'Miércoles',
  'days.JUEVES': 'Jueves',
  'days.VIERNES': 'Viernes',
  'days.SABADO': 'Sábado',
  'days.DOMINGO': 'Domingo',

  'frequency.DIARIA': 'Diaria',
  'frequency.SEMANAL': 'Semanal',
  'frequency.QUINCENAL': 'Quincenal',
  'frequency.MENSUAL': 'Mensual',

  'routes.maxSaleHelp':
    'Ingrese el valor máximo de la venta que se permite a la ruta, si se supera este monto se solicita aprobación al administrador/coordinador de la ruta.',
  'routes.expensesHelp':
    'Ingrese el valor máximo de gasto que se permite a la ruta, si se supera este monto se solicita aprobación al administrador/coordinador de la ruta.',

  // Cobro de la plataforma a las unidades (PROP-002). Los textos describen qué
  // mostrará la pantalla y qué falta por definir: ninguno enuncia una regla,
  // un precio, una periodicidad ni un estado concreto, porque nada de eso está
  // definido todavía.
  'platform.title': 'Cobro de la plataforma',
  'platform.description':
    'Facturación del uso de la plataforma a cada unidad. Es un cobro distinto del cobro operativo de cartera a los clientes de la ruta.',
  'platform.pendingNotice':
    'Módulo pendiente de definición de negocio (PROP-002). La pantalla queda preparada, pero no muestra datos: las reglas todavía no están definidas y el backend aún no expone los servicios correspondientes.',
  'platform.pendingValue': 'Pendiente de definición',
  'platform.unit': 'Unidad',
  'platform.sectionUnitBilling': 'Configuración de cobro de la unidad',
  'platform.sectionPeriodicity': 'Periodicidad de facturación',
  'platform.sectionPlan': 'Plan / precio asignado',
  'platform.sectionBillingStatus': 'Estado de facturación y pago',
  'platform.sectionUnitStatus': 'Estado de la unidad',
  'platform.sectionBillingContact': 'Responsable de facturación',
  'platform.sectionPaymentMethod': 'Método de pago',
  'platform.openQuestionsTitle': 'Definiciones pendientes (PROP-002)',
  'platform.openQuestionsIntro': 'Son decisiones de negocio/comercial. Hasta que se tomen, no se construyen las reglas de este módulo.',
  'platform.question1': 'Periodicidad del cobro: con qué frecuencia se factura a cada unidad, y si es igual para todas.',
  'platform.question2': 'Límite de usuarios por unidad, y si el precio depende de esa cantidad o es un valor fijo por unidad.',
  'platform.question3': 'Bloqueo por no pago: desde cuántos días de mora, si es total o parcial, y cómo se reactiva tras el pago.',
  'platform.question4': 'Recordatorios de pago: anticipación, canal y cuántos se envían antes del bloqueo.',
  'platform.question5': 'Qué ocurre con los datos y la cartera de una unidad bloqueada por no pago.',
  'platform.question6': 'Quién recibe la factura por parte de la unidad (rol o contacto responsable del pago).',
  'platform.question7': 'Método de pago del servicio.',

  // Gestion de trabajadores (US-006 crear, US-007 dispositivos, US-008 listado).
  'workers.moduleTitle': 'Gestión de trabajadores',
  'workers.tabCreate': 'Crear nuevo trabajador',
  'workers.tabList': 'Trabajadores',
  'workers.tabDevices': 'Vincular dispositivos',
  'workers.noTabs': 'No tienes permisos para ninguna opción de este módulo.',

  'workers.searchPlaceholder': 'Buscar por nombre, apodo, documento, celular...',
  'workers.allStatuses': 'Todos los estados',
  'workers.statusActive': 'Activo',
  'workers.statusInactive': 'Inactivo',
  'workers.columnPin': 'PIN',
  'workers.columnFullName': 'Nombre completo',
  'workers.columnNickname': 'Apodo',
  'workers.columnPhone': 'Celular',
  'workers.columnUnit': 'Unidad',
  'workers.pinNeverLinked': '— sin vincular —',
  'workers.listEmpty': 'No hay trabajadores que coincidan con la búsqueda.',
  'workers.openActions': 'Acciones del trabajador',
  'workers.actionActivate': 'Activar',
  'workers.actionDeactivate': 'Desactivar',
  'workers.actionChangePassword': 'Cambiar contraseña',
  'workers.deactivateTitle': 'Confirmar desactivación',
  'workers.deactivateConfirm': '¿Desea desactivar a {{nombre}}? Esto libera su unidad y desvincula su dispositivo.',
  'workers.activateError': 'No se pudo activar el trabajador.',
  'workers.deactivateError': 'No se pudo desactivar el trabajador.',

  'workers.createTitle': 'Crear nuevo trabajador',
  'workers.editTitle': 'Editar trabajador',
  'workers.sectionUnit': 'Unidad',
  'workers.unit': 'Unidad',
  'workers.unitHelp': 'Solo unidades sin trabajador asignado y de su perfil.',
  'workers.selectUnit': 'Seleccione unidad',
  'workers.unitsEmpty': 'No hay unidades disponibles para asignar.',
  'workers.sectionPersonal': 'Datos personales',
  'workers.firstName': 'Primer nombre',
  'workers.secondName': 'Segundo nombre',
  'workers.firstSurname': 'Primer apellido',
  'workers.secondSurname': 'Segundo apellido',
  'workers.nickname': 'Apodo',
  'workers.sectionOrigin': 'Origen e identificación',
  'workers.birthCountry': 'País natal',
  'workers.birthState': 'Estado natal',
  'workers.birthCity': 'Ciudad natal',
  'workers.documentType': 'Tipo de documento',
  'workers.selectDocumentType': 'Seleccione tipo de documento',
  'workers.documentTypeHelp': 'La lista depende del país natal e incluye pasaporte.',
  'workers.documentTypeNeedsCountry': 'Seleccione primero el país natal',
  'workers.document': 'Documento',
  'workers.documentHelp': 'Único; la validación depende del tipo elegido.',
  'workers.sectionContact': 'Contacto',
  'workers.email': 'Correo principal',
  'workers.phone': 'Número celular principal',
  'workers.phoneAdditional': 'Celular adicional',
  'workers.addPhone': 'Agregar celular adicional',
  'workers.removePhone': 'Quitar celular',
  'workers.sectionResidence': 'Residencia',
  'workers.residenceCountry': 'País residencia',
  'workers.residenceState': 'Estado residencia',
  'workers.residenceCity': 'Ciudad residencia',
  'workers.address': 'Dirección principal',
  'workers.addressAdditional': 'Dirección adicional',
  'workers.addAddress': 'Agregar dirección adicional',
  'workers.removeAddress': 'Quitar dirección',
  'workers.sectionAccess': 'Acceso',
  'workers.password': 'Contraseña',
  'workers.passwordHelp': 'Con esta contraseña el trabajador inicia sesión. Mínimo 8 caracteres.',
  'workers.passwordConfirm': 'Confirmar contraseña',
  'workers.sectionAttachments': 'Adjuntos',
  'workers.attachmentsField': 'Seleccione archivo',
  'workers.attachmentsHelp': 'Aquí puede adjuntar la información del documento de identidad y foto del trabajador',
  'workers.attachmentsFormats': 'Opcional. Imágenes (JPG/PNG) y PDF.',
  'workers.attachmentsInvalidFile': 'Archivo no válido. Use JPG, PNG o PDF.',
  'workers.removeAttachment': 'Quitar adjunto',
  'workers.chooseFiles': 'Elegir archivos',
  'workers.noFileSelected': 'Ningún archivo seleccionado',
  'workers.createError': 'No se pudo crear el trabajador.',
  'workers.updateError': 'No se pudo guardar el trabajador.',
  'workers.created': 'Trabajador creado y vinculado a la unidad.',
  'workers.updated': 'Trabajador actualizado.',

  'workers.validation.unit': 'La unidad es obligatoria',
  'workers.validation.firstName': 'El primer nombre es obligatorio',
  'workers.validation.firstSurname': 'El primer apellido es obligatorio',
  'workers.validation.nickname': 'El apodo es obligatorio',
  'workers.validation.documentType': 'El tipo de documento es obligatorio',
  'workers.validation.document': 'El documento es obligatorio',
  'workers.validation.documentFormat': 'El documento no tiene el formato válido para el tipo de documento seleccionado',
  'workers.validation.email': 'Ingresa un correo con formato válido',
  'workers.validation.phone': 'El celular principal es obligatorio',
  'workers.validation.residenceCountry': 'El país de residencia es obligatorio',
  'workers.validation.residenceState': 'El estado de residencia es obligatorio',
  'workers.validation.residenceCity': 'La ciudad de residencia es obligatoria',
  'workers.validation.address': 'La dirección principal es obligatoria',
  'workers.validation.password': 'La contraseña debe tener al menos 8 caracteres',
  'workers.validation.passwordConfirm': 'Las contraseñas no coinciden',

  'workers.devicesStep1': 'Paso 1 · Seleccione la unidad',
  'workers.devicesUnitHelp': 'Al seleccionar, se muestra el dispositivo de la unidad o se habilita vincular uno.',
  'workers.devicesSelectUnitFirst': 'Seleccione una unidad para continuar.',
  'workers.deviceCaseA': 'Esta unidad ya tiene un dispositivo vinculado',
  'workers.deviceCaseB': 'Esta unidad no tiene dispositivo vinculado',
  'workers.deviceWorker': 'Trabajador',
  'workers.devicePin': 'PIN dispositivo',
  'workers.deviceStatus': 'Estado',
  'workers.deviceLinkedAt': 'Fecha de vinculación',
  'workers.deviceLinked': 'Vinculado',
  'workers.unlinkReason': 'Motivo desvinculación',
  'workers.selectReason': 'Seleccione motivo',
  'workers.reasonUnitChange': 'Cambio de unidad',
  'workers.reasonDeactivated': 'Desactivado',
  'workers.reasonLostStolen': 'Dispositivo robado o perdido',
  'workers.unlink': 'Desvincular',
  'workers.unlinkTwoSteps': 'Seleccione el motivo (obligatorio) y presione Desvincular; luego confirme en el diálogo.',
  'workers.unlinkConfirmTitle': 'Confirmar desvinculación',
  'workers.unlinkConfirm': '¿Desea desvincular el dispositivo de {{nombre}}?',
  'workers.unlinkReasonLine': 'Motivo: {{motivo}}',
  'workers.unlinkError': 'No se pudo desvincular el dispositivo.',
  'workers.link': 'Vincular',
  'workers.enterPin': 'Ingrese el PIN del dispositivo del trabajador',
  'workers.pinHelp':
    'El PIN de 6 dígitos lo genera el sistema y se muestra en la app del trabajador cuando inicia sesión desde su teléfono.',
  'workers.linkError': 'No se pudo vincular el dispositivo.',
  'workers.linked': 'Dispositivo vinculado.',
  'workers.unlinked': 'Dispositivo desvinculado.',

  // Registro de actividad / logs (US-009). "Logs" es el nombre técnico del
  // módulo; el nombre visible para el usuario es "Registro de actividad".
  'activityLog.title': 'Registro de actividad',
  'activityLog.unit': 'Unidad',
  'activityLog.selectUnit': 'Selecciona una unidad',
  'activityLog.noUnits': 'No tienes unidades vinculadas a tu perfil.',
  'activityLog.dateFrom': 'Fecha desde',
  'activityLog.dateTo': 'Fecha hasta',
  'activityLog.search': 'Consultar',
  'activityLog.invalidRange': 'La fecha desde no puede ser posterior a la fecha hasta.',
  'activityLog.emptyState': 'Selecciona una unidad y un rango de fechas para consultar el registro de actividad.',
  'activityLog.noResults': 'No se encontraron registros para los filtros seleccionados.',
  'activityLog.columnDate': 'Fecha y hora',
  'activityLog.columnUser': 'Usuario',
  'activityLog.columnOrigin': 'Origen',
  'activityLog.columnUnit': 'Unidad',
  'activityLog.columnModule': 'Módulo',
  'activityLog.columnEntity': 'Entidad afectada',
  'activityLog.columnProcess': 'Proceso',
  'activityLog.columnDetail': 'Detalle',
  'activityLog.columnBefore': 'Valor anterior',
  'activityLog.columnAfter': 'Valor nuevo',
  'activityLog.noValue': '—',
  'activityLog.filterUser': 'Filtrar por usuario',
  'activityLog.filterOriginAll': 'Todos los orígenes',
  'activityLog.filterModuleAll': 'Todos los módulos',
  'activityLog.filterProcessAll': 'Todos los procesos',
  'activityLog.filterEntity': 'Filtrar por entidad',
  'activityLog.filterDetail': 'Filtrar por detalle',
  'activityLog.clearFilters': 'Limpiar filtros',
  'activityLog.exportExcel': 'Descargar Excel',
  'activityLog.exporting': 'Descargando...',
  'activityLog.originWeb': 'Web',
  'activityLog.originMobile': 'Móvil',
  'activityLog.moduleCaja': 'Caja',
  'activityLog.moduleTrabajadores': 'Trabajadores',
  'activityLog.moduleDispositivos': 'Dispositivos',
  'activityLog.moduleVentas': 'Ventas',
  'activityLog.modulePagos': 'Pagos',
  'activityLog.moduleGastos': 'Gastos',
  'activityLog.moduleIngresos': 'Ingresos',
  'activityLog.moduleClientes': 'Clientes',
  'activityLog.moduleRutas': 'Rutas',
  'activityLog.moduleCargueCartera': 'Cargue de cartera',
  'activityLog.processCreation': 'Creación',
  'activityLog.processModification': 'Modificación',
  'activityLog.processDeletion': 'Eliminación',
  'cash.uploadPortfolio': 'Subir cartera',
  'cartera.title': 'Subir cartera',
  'cartera.route': 'Ruta',
  'cartera.back': 'Volver a cajas',
  'cartera.intro':
    'Cargue de forma masiva la cartera de esta ruta a partir de la plantilla. Los clientes cargados quedan vinculados a la ruta.',
  'cartera.notCashNotice': 'Cargar cartera registra deuda por cobrar: no es dinero recibido y no modifica los valores de caja.',
  'cartera.stepTemplate': 'Paso 1 · Descargue la plantilla',
  'cartera.stepFile': 'Paso 2 · Seleccione la plantilla diligenciada',
  'cartera.stepRun': 'Paso 3 · Realice el cargue',
  'cartera.fieldsTitle': 'Campos de la plantilla',
  'cartera.fieldsHelp': 'Los campos marcados con * son obligatorios.',
  'cartera.frequenciesHelp': 'Frecuencias permitidas: {{frecuencias}}. La fecha de la primera cuota va en formato dd/mm/aaaa.',
  'cartera.requiredField': 'obligatorio',
  'cartera.downloadTemplate': 'Descargar plantilla',
  'cartera.downloading': 'Descargando...',
  'cartera.downloadError': 'No se pudo descargar la plantilla.',
  'cartera.fileInputLabel': 'Plantilla diligenciada (.xlsx)',
  'cartera.selectFile': 'Seleccionar archivo',
  'cartera.replaceFile': 'Reemplazar archivo',
  'cartera.removeFile': 'Quitar archivo',
  'cartera.noFile': 'Ningún archivo seleccionado',
  'cartera.fileReady': 'Listo para cargar',
  'cartera.fileInvalidExtension': 'El archivo debe ser una plantilla de Excel (.xlsx).',
  'cartera.fileEmpty': 'El archivo está vacío.',
  'cartera.fileTooLarge': 'El archivo supera el tamaño máximo permitido.',
  'cartera.execute': 'Realizar cargue',
  'cartera.validate': 'Validar archivo',
  'cartera.selectFirst': 'Seleccione un archivo para continuar.',
  'cartera.processing': 'Procesando el cargue. No cierre ni recargue esta página.',
  'cartera.validating': 'Validando el archivo...',
  'cartera.successTitle': 'Cartera cargada correctamente',
  'cartera.successDetail': 'Se cargaron {{clientes}} clientes con su cartera ({{cuotas}} cuotas). Saldo total por cobrar: {{saldo}}.',
  'cartera.validTitle': 'El archivo es válido',
  'cartera.validDetail':
    'No se encontraron errores. Al realizar el cargue se crearán {{clientes}} clientes con {{cuotas}} cuotas y un saldo por cobrar de {{saldo}}. Todavía no se ha cargado nada.',
  'cartera.loadAnother': 'Cargar otro archivo',
  'cartera.rejectedTitle': 'Archivo rechazado: no se cargó ningún registro',
  'cartera.rejectedDetail':
    'Se encontraron {{errores}} errores en las {{filas}} filas leídas. El cargue es todo o nada: mientras exista un error no se carga ningún cliente. Corrija el archivo en Excel y vuelva a seleccionarlo.',
  'cartera.colRow': 'Fila',
  'cartera.colField': 'Campo',
  'cartera.colDescription': 'Descripción',
  'cartera.fileLevel': 'Archivo',
  'cartera.unexpectedError': 'No se pudo completar la operación',
  'cartera.unexpectedErrorDetail': 'Ocurrió un error inesperado.',
  'cartera.canRetry': 'No se cargó ningún registro. Puede volver a intentarlo.',
  'cartera.noPermission': 'No tienes permiso para subir cartera.',
  'cartera.routeNotFound': 'La ruta no existe o no está vinculada a tu perfil.',
  'profiles.pageTitle': 'Roles y permisos',
  'profiles.tabsLabel': 'Perfiles',
  'profiles.tabNew': 'Nuevo Perfil',
  'profiles.tabList': 'Lista de Perfiles',
  'profiles.name': 'Nombre del perfil',
  'profiles.namePlaceholder': 'Ej. Supervisor',
  'profiles.nameRequired': 'El nombre del perfil es obligatorio',
  'profiles.nameMin': 'El nombre debe tener al menos 3 caracteres',
  'profiles.status': 'Estado',
  'profiles.statusActive': 'Activo',
  'profiles.statusInactive': 'Inactivo',
  'profiles.import': '¿Desea importar perfil?',
  'profiles.importSelect': 'Perfiles creados',
  'profiles.importPlaceholder': 'Seleccione un perfil',
  'profiles.importLoading': 'Cargando perfiles…',
  'profiles.importEmpty': 'Aún no hay perfiles creados para importar.',
  'profiles.importError': 'No se pudieron cargar los perfiles creados.',
  'profiles.importLoaded': 'Permisos cargados desde el perfil «{{nombre}}». Puede modificarlos antes de guardar.',
  'profiles.importKept': '{{cantidad}} permisos de «{{nombre}}» que esta tabla aún no desglosa se conservarán al guardar.',
  'profiles.permissionsTitle': 'Permisos del perfil',
  'profiles.permissionsHelp': 'Defina qué podrá hacer este perfil. Son los permisos del perfil que está creando, no los suyos.',
  'profiles.loadingPermissions': 'Cargando permisos…',
  'profiles.permissionsError': 'No se pudo cargar el catálogo de permisos.',
  'profiles.retry': 'Reintentar',
  'profiles.save': 'Guardar Perfil',
  'profiles.saving': 'Guardando…',
  'profiles.saved': 'Perfil «{{nombre}}» creado correctamente.',
  'profiles.saveError': 'No se pudo guardar el perfil.',
  'profiles.colPermission': 'Permiso',
  'profiles.tableLabel': 'Permisos por módulo',
  'profiles.level.none': 'Ninguno',
  'profiles.level.read': 'Lectura',
  'profiles.level.full': 'Total',
  'profiles.level.noneHelp': 'sin acceso al módulo ni a la acción.',
  'profiles.level.readHelp': 'puede ver la información del módulo, sin modificarla.',
  'profiles.level.fullHelp': 'acceso completo al módulo, o puede ejecutar la acción.',
  'profiles.legendTitle': 'Significado de los niveles',
  'profiles.legendActions': 'Las acciones son operaciones puntuales: solo se permiten (Total) o no (Ninguno).',
  'profiles.kind.module': 'Módulo',
  'profiles.kind.action': 'Acción',
  'profiles.onlyActions': 'Solo tiene acciones',
  'profiles.unavailable': 'No disponible',
  'profiles.unavailableHelp': 'El servidor aún no tiene este permiso, por eso no se puede asignar.',
  'profiles.module.dashboard': 'Dashboard',
  'profiles.module.rutas': 'Rutas',
  'profiles.module.trabajadores': 'Gestión de trabajadores',
  'profiles.module.caja': 'Caja',
  'profiles.module.cartera': 'Cargue de cartera',
  'profiles.module.logs': 'Registro de actividad (Logs)',
  'profiles.module.roles': 'Roles y permisos',
  'profiles.module.usuarios': 'Usuarios',
  'profiles.action.rutas.crear': 'Crear ruta',
  'profiles.action.rutas.editar': 'Editar ruta',
  'profiles.action.trabajadores.crear': 'Crear trabajador',
  'profiles.action.trabajadores.dispositivos': 'Vincular / desvincular dispositivos',
  'profiles.action.caja.abrir': 'Abrir caja',
  'profiles.action.caja.cerrar': 'Cerrar caja',
  'profiles.action.caja.cierre-forzado': 'Cierre forzado',
  'profiles.action.caja.reabrir': 'Reabrir caja',
  'profiles.action.caja.operar': 'Confirmar caja, registrar gasto y registrar ingreso',
  'profiles.action.cartera.subir': 'Subir cartera',
  'profiles.list.error': 'No se pudo cargar la lista de perfiles.',
  'cartera.selectRoute': 'Seleccione una ruta',
  'cartera.selectRouteFirst': 'Seleccione la ruta a la que se cargará la cartera.',
  'workers.alertsTitle': 'Solicitudes de vinculación pendientes',
  'workers.alertPending': '{{nombre}} ({{unidad}}) inició sesión desde {{equipo}} y espera que autorice su PIN.',
  'workers.alertDeviceChange':
    '¡Alerta! {{nombre}} ({{unidad}}) inició sesión desde un dispositivo distinto: {{equipo}}. Se desvinculó automáticamente {{anterior}}. Pídale el PIN que ve en su app para vincular el nuevo.',
  'workers.alertAttend': 'Atender',
  'workers.pendingForUnit': '{{nombre}} espera la vinculación de {{equipo}}. Pídale el PIN de 6 dígitos que ve en su app.',
  'workers.noPendingForUnit': 'El trabajador aún no ha iniciado sesión desde su teléfono: el PIN se genera en ese momento.',
  'workers.deviceModel': 'Equipo',
  'workers.deviceUnknown': 'Dispositivo sin identificar',
  'clients.moduleTitle': 'Clientes',
  'clients.tabNew': 'Nuevo Cliente',
  'clients.tabList': 'Lista de Clientes',
  'clients.newTitle': 'Nuevo cliente',
  'clients.editTitle': 'Editar cliente',
  'clients.statusEditHint': 'El estado se cambia desde la lista, con confirmación.',
  'clients.requiredHint': 'Los campos marcados con * son obligatorios.',
  'clients.route': 'Ruta',
  'clients.routePlaceholder': 'Seleccione ruta',
  'clients.routeHelp': 'De la ruta se toman el país, los tipos de documento y las ciudades.',
  'clients.country': 'País de la ruta: {{pais}}',
  'clients.selectRouteFirst': 'Seleccione primero una ruta',
  'clients.city': 'Ciudad',
  'clients.cityPlaceholder': 'Busque y seleccione la ciudad',
  'clients.cityNoOptions': 'No hay ciudades que coincidan',
  'clients.firstName': 'Nombre',
  'clients.lastName': 'Apellidos',
  'clients.nickname': 'Apodo',
  'clients.email': 'Correo electrónico',
  'clients.documentType': 'Tipo de documento',
  'clients.documentTypePlaceholder': 'Seleccione el tipo',
  'clients.documentNumber': 'Número de documento',
  'clients.birthDate': 'Fecha de nacimiento',
  'clients.address': 'Dirección',
  'clients.neighborhood': 'Barrio',
  'clients.phone': 'Celular',
  'clients.phone2': 'Celular 2',
  'clients.comment': 'Comentario',
  'clients.activity': 'Actividad económica',
  'clients.activityNone': 'Sin actividad',
  'clients.activityEmpty': 'Aún no hay actividades económicas disponibles.',
  'clients.retry': 'Reintentar',
  'clients.catalogsError': 'No se pudieron cargar las opciones de la ruta.',
  'clients.routesError': 'No se pudieron cargar tus rutas.',
  'clients.noRoutes': 'Tu perfil no tiene rutas vinculadas: no hay clientes que gestionar.',
  'clients.loadingClient': 'Cargando cliente…',
  'clients.clientNotFound': 'El cliente no existe o no es de tu perfil.',
  'clients.backToList': 'Volver a la lista',
  'clients.created': 'Cliente «{{nombre}}» creado correctamente.',
  'clients.updated': 'Cliente «{{nombre}}» actualizado correctamente.',
  'clients.saveError': 'No se pudo guardar el cliente.',
  'clients.validation.route': 'La ruta es obligatoria',
  'clients.validation.firstName': 'El nombre es obligatorio',
  'clients.validation.lastName': 'Los apellidos son obligatorios',
  'clients.validation.nickname': 'El apodo es obligatorio',
  'clients.validation.emailFormat': 'El correo no tiene un formato válido',
  'clients.validation.documentType': 'El tipo de documento es obligatorio',
  'clients.validation.documentNumber': 'El número de documento es obligatorio',
  'clients.validation.documentFormat': 'El número de documento no cumple el formato del tipo elegido',
  'clients.validation.birthDateFuture': 'La fecha de nacimiento no puede ser futura',
  'clients.validation.address': 'La dirección es obligatoria',
  'clients.validation.city': 'La ciudad es obligatoria',
  'clients.validation.phone': 'El celular es obligatorio',
  'clients.validation.phoneFormat': 'El número de celular no es válido',
  'clients.validation.commentMax': 'El comentario admite hasta 500 caracteres',
  'clients.searchPlaceholder': 'Buscar por documento, nombre, apellido o apodo',
  'clients.search': 'Buscar',
  'clients.allRoutes': 'Ver todas las rutas',
  'clients.selectRouteOrAll': 'Seleccione una ruta o marque «Ver todas las rutas».',
  'clients.columnRoute': 'Ruta',
  'clients.columnClient': 'Cliente',
  'clients.columnEmail': 'Email',
  'clients.columnDocument': 'Número de documento',
  'clients.columnOptions': 'Opciones',
  'clients.listEmpty': 'No hay clientes que coincidan con el filtro.',
  'clients.toggleStatus': 'Cambiar estado de {{nombre}}',
  'clients.statusConfirmTitle': 'Cambiar estado del cliente',
  'clients.statusConfirm': '¿Desea cambiar el estado del cliente {{nombre}}? Su historial se conservará.',
  'clients.statusConfirmNew': 'Pasará a estar {{estado}}.',
  'clients.statusConfirmAction': 'Cambiar estado',
  'clients.statusChanged': 'El estado de «{{nombre}}» ahora es {{estado}}.',
  'clients.statusError': 'No se pudo cambiar el estado del cliente.',
  'profiles.module.clientes': 'Clientes',
  'profiles.list.searchPlaceholder': 'Ejem: Nombre',
  'profiles.list.search': 'Buscar',
  'profiles.list.showActive': 'Ver activos',
  'profiles.list.showInactive': 'Ver inactivos',
  'profiles.list.noStatusSelected': 'Marca «Ver activos» o «Ver inactivos» para ver perfiles.',
  'profiles.list.colEdit': 'Editar',
  'profiles.list.colCode': 'Código',
  'profiles.list.colName': 'Nombre',
  'profiles.list.colUsers': 'Usuarios',
  'profiles.list.colStatus': 'Estado',
  'profiles.list.edit': 'Editar perfil',
  'profiles.list.editProfile': 'Editar el perfil {{nombre}}',
  'profiles.list.statusOf': 'Estado de {{nombre}}: {{estado}}',
  'profiles.list.statusVisualHint': 'Solo visual: el estado se cambia al editar el perfil.',
  'profiles.list.showing': 'Mostrando {{desde}} a {{hasta}} de {{total}} registros',
  'profiles.list.pagination': 'Paginación de perfiles',
  'profiles.list.legend':
    'El toggle de Estado es solo visual. El estado se cambia en Editar, con confirmación. No se puede desactivar un perfil con usuarios asignados.',
  'profiles.list.empty': 'No hay perfiles que coincidan con la búsqueda.',
  'profiles.editTitle': 'Editar perfil',
  'profiles.statusOfProfile': 'Estado del perfil',
  'profiles.cannotDeactivate':
    'No se puede desactivar este perfil: tiene {{cantidad}} usuarios asignados. Reasígnalos a otro perfil antes de desactivarlo.',
  'profiles.cannotDeactivateOne':
    'No se puede desactivar este perfil: tiene 1 usuario asignado. Reasígnalo a otro perfil antes de desactivarlo.',
  'profiles.usersAssigned': '{{cantidad}} usuarios tienen este perfil.',
  'profiles.usersAssignedOne': '1 usuario tiene este perfil.',
  'profiles.confirmStatusTitle': 'Confirmar cambio de estado',
  'profiles.confirmDeactivate': '¿Desea desactivar el perfil «{{nombre}}»? No se podrá asignar a usuarios mientras esté inactivo.',
  'profiles.confirmActivate': '¿Desea activar el perfil «{{nombre}}»?',
  'profiles.confirmStatusAction': 'Cambiar estado',
  'profiles.updated': 'Perfil «{{nombre}}» actualizado correctamente.',
  'profiles.loadingProfile': 'Cargando perfil…',
  'profiles.profileNotFound': 'El perfil no existe.',
  'profiles.backToList': 'Volver a la lista',
  'lockouts.pageTitle': 'Bloqueos de la app móvil',
  'lockouts.subtitle':
    'Trabajadores cuya app quedó bloqueada. Solo el bloqueo por intentos fallidos requiere que un administrador lo libere; los demás los libera el trabajador con su clave.',
  'lockouts.searchPlaceholder': 'Buscar por trabajador o equipo',
  'lockouts.filterStatus': 'Estado del bloqueo',
  'lockouts.filterCause': 'Causal',
  'lockouts.allCauses': 'Todas las causales',
  'lockouts.showAll': 'Ver también los que libera el trabajador',
  'lockouts.showAllHint':
    'Estos bloqueos (inactividad, bloqueo del celular, manual) los libera el trabajador con su clave: son solo informativos.',
  'lockouts.empty': 'No hay bloqueos que mostrar.',
  'lockouts.loadError': 'No se pudieron cargar los bloqueos.',
  'lockouts.deviceUnknown': 'Equipo sin identificar',
  'lockouts.column.worker': 'Trabajador',
  'lockouts.column.route': 'Ruta',
  'lockouts.column.blockedAt': 'Fecha y hora de bloqueo',
  'lockouts.column.cause': 'Causal',
  'lockouts.column.device': 'Modelo / dispositivo',
  'lockouts.column.location': 'Ubicación GPS',
  'lockouts.column.attempts': 'Historial de intentos',
  'lockouts.column.status': 'Estado',
  'lockouts.cause.INACTIVIDAD': 'Inactividad',
  'lockouts.cause.BLOQUEO_SO': 'Bloqueo del celular',
  'lockouts.cause.INTENTOS_FALLIDOS': 'Intentos fallidos',
  'lockouts.cause.MANUAL': 'Bloqueo manual',
  'lockouts.state.BLOQUEADO': 'Bloqueado',
  'lockouts.state.DESBLOQUEADO': 'Desbloqueado',
  'lockouts.state.codeIssued': 'Código emitido (vence {{hora}})',
  'lockouts.method.CLAVE_PROPIA': 'Clave del trabajador',
  'lockouts.method.ADMIN_SENAL': 'Señal del administrador',
  'lockouts.method.ADMIN_OTP': 'Código de un solo uso',
  'lockouts.method.ADMIN_CLAVE_RESTABLECIDA': 'Clave restablecida por el administrador',
  'lockouts.gps.SIN_PERMISO': 'Sin permiso de ubicación',
  'lockouts.gps.NO_DISPONIBLE': 'Ubicación no disponible',
  'lockouts.gps.TIMEOUT': 'No se obtuvo a tiempo',
  'lockouts.gps.OK': 'Sin coordenadas',
  'lockouts.location.viewMap': 'Ver en Google Maps',
  'lockouts.location.accuracy': 'Precisión ±{{m}} m',
  'lockouts.location.capturedAt': 'Tomada el {{fecha}}',
  'lockouts.attemptsCount': '{{n}} intentos',
  'lockouts.viewHistoryOf': 'Ver historial de intentos de {{nombre}}',
  'lockouts.unlockDevice': 'Desbloquear dispositivo',
  'lockouts.unlockDeviceOf': 'Desbloquear el dispositivo de {{nombre}}',
  'lockouts.detail.title': 'Detalle del bloqueo',
  'lockouts.detail.attemptsTitle': 'Historial de intentos',
  'lockouts.detail.noAttempts': 'No se registraron intentos fallidos.',
  'lockouts.detail.attempt': 'Intento {{n}}',
  'lockouts.detail.deviceClock': 'Hora del equipo',
  'lockouts.detail.serverClock': 'Hora del servidor',
  'lockouts.detail.authorizationTitle': 'Autorización del desbloqueo',
  'lockouts.detail.authorizedBy': 'Autorizado por',
  'lockouts.detail.authorizedAt': 'Fecha de autorización',
  'lockouts.detail.reason': 'Motivo',
  'lockouts.detail.signature': 'Firma de verificación',
  'lockouts.detail.method': 'Desbloqueado mediante',
  'lockouts.unlock.title': 'Desbloquear dispositivo',
  'lockouts.unlock.intro': 'Vas a autorizar el desbloqueo de la app de {{nombre}}. Confirma tu identidad con tu contraseña.',
  'lockouts.unlock.password': 'Tu contraseña',
  'lockouts.unlock.passwordHelp': 'Verificación de seguridad: no se guarda.',
  'lockouts.unlock.passwordRequired': 'Escribe tu contraseña para autorizar',
  'lockouts.unlock.mode': 'Cómo llega la autorización al trabajador',
  'lockouts.unlock.modeSignal': 'Señal a la app: se libera sola en segundos',
  'lockouts.unlock.modeCode': 'Código de un solo uso: se lo dicto al trabajador',
  'lockouts.unlock.reason': 'Motivo del desbloqueo',
  'lockouts.unlock.reasonRequired': 'El motivo es obligatorio',
  'lockouts.unlock.reasonMin': 'El motivo debe tener al menos 3 caracteres',
  'lockouts.unlock.note': 'Desbloquear no cambia la clave: el trabajador recupera sus 3 intentos. Si la olvidó, restablécela en Usuarios.',
  'lockouts.unlock.confirm': 'Desbloquear',
  'lockouts.unlock.unlocking': 'Verificando…',
  'lockouts.unlock.error': 'No se pudo desbloquear el dispositivo.',
  'lockouts.unlock.signalSent': 'Listo: la app de {{nombre}} se desbloqueará en unos segundos.',
  'lockouts.unlock.codeTitle': 'Código de desbloqueo',
  'lockouts.unlock.codeIntro': 'Dícteselo a {{nombre}}. Es válido hasta las {{hora}}.',
  'lockouts.unlock.codeLabel': 'Código de 6 dígitos',
  'lockouts.unlock.codeOnce': 'Este código se muestra una sola vez y sirve para un único desbloqueo. Si lo pierdes, emite otro.',
  'lockouts.unlock.copy': 'Copiar código',
  'lockouts.unlock.copied': 'Código copiado',
  'profiles.module.bloqueos': 'Bloqueos de la app',
  'profiles.action.bloqueos.desbloquear': 'Desbloquear dispositivos',
  'activityLog.moduleBloqueos': 'Bloqueos de la app',
  'mainDashboard.title': 'Desempeño de la ruta',
  'mainDashboard.routeFilter': 'Filtro de ruta',
  'mainDashboard.allRoutes': 'Todas las rutas',
  'mainDashboard.routesLoadError': 'No se pudieron cargar las rutas.',
  'mainDashboard.noRoutesVisible': 'No tienes rutas visibles.',
  'mainDashboard.boxFilter': 'Filtro de caja',
  'mainDashboard.selectBox': 'Selecciona una caja',
  'mainDashboard.selectRouteFirst': 'Elige primero una ruta',
  'mainDashboard.boxesLoadError': 'No se pudieron cargar las cajas de la ruta.',
  'mainDashboard.noBoxes': 'Esta ruta todavía no tiene cajas.',
  'mainDashboard.actions': 'Más acciones',
  'mainDashboard.seeMoreBoxes': 'Ver más cajas',
  'mainDashboard.openNewBox': 'Abrir nueva caja',
  'mainDashboard.createExpense': 'Crear gasto',
  'mainDashboard.createIncome': 'Crear ingreso',
  'mainDashboard.actionUnavailable': 'Disponible cuando exista el endpoint web para crearlo en la caja de otra persona (US-004).',
  'mainDashboard.uploadPortfolio': 'Subir cartera',
  'mainDashboard.refresh': 'Refrescar',
  'mainDashboard.tabsLabel': 'Desempeño de la ruta',
  'mainDashboard.tabSummary': 'Resumen',
  'mainDashboard.tabDetails': 'Detalles',
  'mainDashboard.selectBoxFirst': 'Elige una caja para ver su resumen.',
  'mainDashboard.panelCashTitle': 'Caja Final',
  'mainDashboard.entriesGroup': 'Entradas',
  'mainDashboard.exitsGroup': 'Salidas',
  'mainDashboard.initialCash': 'Caja Inicial',
  'mainDashboard.collection': 'Recaudo',
  'mainDashboard.collectionTooltip': 'Recaudo de Ruta + Recaudo Adicional',
  'mainDashboard.income': 'Ingresos',
  'mainDashboard.totalSales': 'Total Ventas',
  'mainDashboard.expenses': 'Gastos',
  'mainDashboard.withdrawals': 'Retiros',
  'mainDashboard.finalCashResult': 'Caja Final',
  'mainDashboard.summaryLoadError': 'No se pudo cargar el resumen de la caja.',
  'mainDashboard.cash': 'Efectivo',
  'mainDashboard.transfer': 'Transferencia electrónica',
  'mainDashboard.expandBreakdown': 'Ver desglose de {{label}}',
  'mainDashboard.collapseBreakdown': 'Ocultar desglose de {{label}}',
  'mainDashboard.panelPerformanceTitle': 'Desempeño (Recaudo)',
  'mainDashboard.expectedCollection': 'Pretendido',
  'mainDashboard.clientsToCollect': 'Clientes a recaudar',
  'mainDashboard.additionalCollection': 'Recaudo Adicional',
  'mainDashboard.complianceRate': '% de Cumplimiento',
  'mainDashboard.unscheduledClients': 'Clientes No Programados',

  'mainDashboard.details.loadError': 'No se pudo cargar la información.',
  'mainDashboard.details.emptyMessage': 'No hay movimientos registrados.',
  'mainDashboard.details.columnClient': 'Cliente',
  'mainDashboard.details.columnPhone': 'Teléfono',
  'mainDashboard.details.columnFinalValue': 'Valor Final',
  'mainDashboard.details.columnPaymentValue': 'Valor del Pago',
  'mainDashboard.details.columnBalance': 'Saldo',
  'mainDashboard.details.columnFrequency': 'Frecuencia',
  'mainDashboard.details.columnSaleDate': 'Fecha de Venta',
  'mainDashboard.details.columnDays': 'Días Mora / Transcurridos',
  'mainDashboard.details.columnId': 'ID',
  'mainDashboard.details.columnDescription': 'Descripción',
  'mainDashboard.details.columnComment': 'Comentario',
  'mainDashboard.details.columnAmount': 'Valor',
  'mainDashboard.details.columnDate': 'Fecha',
  'mainDashboard.details.columnImages': 'Imágenes',
  'mainDashboard.details.columnDestination': 'Destino',
  'mainDashboard.details.collectedTitle': 'Recaudos',
  'mainDashboard.details.unsyncedTitle': 'No Sincronizados',
  'mainDashboard.details.incomeTitle': 'Ingresos',
  'mainDashboard.details.expensesTitle': 'Gastos',
  'mainDashboard.details.withdrawalsTitle': 'Retiros',
  'mainDashboard.details.viewImages': 'Ver imágenes ({{n}})',
  'mainDashboard.details.imagesTitle': 'Comprobantes',

  'movementTypes.moduleTitle': 'Tipos de movimientos',
  'movementTypes.tabNew': 'Tipo de Movimiento',
  'movementTypes.tabHistory': 'Histórico de Movimientos',

  'movementTypes.createTitle': 'Crear Tipo de Movimiento',
  'movementTypes.type': 'Tipo de Movimiento',
  'movementTypes.typeIncome': 'Ingresos',
  'movementTypes.typeExpense': 'Gastos',
  'movementTypes.typeWithdrawal': 'Retiros',
  'movementTypes.country': 'País',
  'movementTypes.countryPlaceholder': 'Selecciona un país',
  'movementTypes.countriesLoadError': 'No se pudieron cargar los países.',
  'movementTypes.name': 'Nombre',
  'movementTypes.namePlaceholder': 'Ej.: Gasolina Moto',
  'movementTypes.observation': 'Observación',
  'movementTypes.observationPlaceholder': 'Ej.: Gasto de combustible solo para motos',
  'movementTypes.observationHelp': 'Campo opcional.',
  'movementTypes.saving': 'Guardando...',
  'movementTypes.created': 'Se creó el movimiento «{{nombre}}».',
  'movementTypes.createError': 'No se pudo crear el tipo de movimiento.',
  'movementTypes.validation.type': 'Selecciona el tipo de movimiento.',
  'movementTypes.validation.country': 'Selecciona un país.',
  'movementTypes.validation.name': 'El nombre es obligatorio.',

  'movementTypes.searchPlaceholder': 'Buscar por observación...',
  'movementTypes.filterCountry': 'Filtro de país',
  'movementTypes.filterType': 'Filtro de tipo',
  'movementTypes.filterStatus': 'Filtro de estado',
  'movementTypes.replicate': 'Replicar a otro país',
  'movementTypes.replicateTitle': 'Replicar a otro país',
  'movementTypes.replicateSourceCountry': 'País origen',
  'movementTypes.replicateTargetCountry': 'País destino',
  'movementTypes.replicateSelectAll': 'Seleccionar todos',
  'movementTypes.replicateSelectRow': 'Seleccionar {{nombre}}',
  'movementTypes.replicateAlreadyExists': 'Ya existe en {{destino}} - se omitirá',
  'movementTypes.replicateSelectedCount': '{{seleccionados}} seleccionados - {{omitidos}} omitidos',
  'movementTypes.replicateEmptyHint': 'Selecciona el país de origen y el país destino para ver los movimientos a replicar.',
  'movementTypes.replicateNoItems': 'El país de origen no tiene tipos de movimiento para replicar.',
  'movementTypes.replicateLoadError': 'No se pudo cargar la previsualización.',
  'movementTypes.replicateAction': 'Replicar',
  'movementTypes.replicateConfirmTitle': 'Confirmar réplica',
  'movementTypes.replicateConfirmDescription': 'Vas a crear {{count}} movimiento(s) en {{destino}}. ¿Continuar?',
  'movementTypes.replicateSuccess': 'Se replicaron {{replicados}}, se omitieron {{omitidos}}.',
  'movementTypes.replicateError': 'No se pudo completar la réplica.',
  'movementTypes.downloadExcel': 'Descargar Excel',
  'movementTypes.exporting': 'Descargando...',
  'movementTypes.exportError': 'No se pudo descargar el archivo.',
  'movementTypes.listEmpty': 'No hay tipos de movimiento registrados.',
  'movementTypes.columnCountry': 'País',
  'movementTypes.columnName': 'Nombre',
  'movementTypes.columnObservation': 'Observación',
  'movementTypes.columnType': 'Tipo',
  'movementTypes.columnIncome': 'Ingresos',
  'movementTypes.columnExpense': 'Gastos',
  'movementTypes.columnWithdrawal': 'Retiros',
  'movementTypes.columnActions': 'Acciones',
  'movementTypes.toggleStatus': 'Cambiar estado de {{nombre}}',
  'movementTypes.activateConfirmTitle': 'Activar movimiento',
  'movementTypes.activateConfirm': '¿Activar «{{nombre}}»? Quedará disponible de inmediato en el móvil.',
  'movementTypes.deactivateConfirmTitle': 'Desactivar movimiento',
  'movementTypes.deactivateConfirm':
    '¿Desactivar «{{nombre}}»? Dejará de estar disponible en el móvil, pero seguirá visible en el Histórico.',
  'movementTypes.activated': 'Se activó «{{nombre}}».',
  'movementTypes.deactivated': 'Se desactivó «{{nombre}}».',
  'movementTypes.statusChangeError': 'No se pudo cambiar el estado del movimiento.'
};

export default es;
